// Maps s3Key -> preview URL for in-flight canvas imports.
// The s3Key matches clip.importedName on the real backend clip.
const previewUrlByS3Key = new Map<string, string>();

export const registerCanvasImportPreview = (s3Key: string, previewUrl: string) => {
  previewUrlByS3Key.set(s3Key, previewUrl);
};

/**
 * Look up a preview URL for a clip that is still transcoding.
 * Returns the URL only if the clip's importedName exactly matches a registered s3Key.
 * Returns undefined if no match — callers should fall back to the processing card.
 */
export const getCanvasImportPreview = (importedName: string | undefined): string | undefined => {
  if (!importedName) {
    return undefined;
  }

  return previewUrlByS3Key.get(importedName);
};

export const releaseCanvasImportPreview = (importedName: string) => {
  const url = previewUrlByS3Key.get(importedName);

  if (url?.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }

  previewUrlByS3Key.delete(importedName);
};
